import React, { useEffect, useState } from "react"

import { useIsFocused } from "../../hooks/use-is-focused"
import { useCurrentRouteScrollOffset } from "../../hooks/use-route-scroll-offset"
import { SystemBars } from "../system-bars"
import { useTokens } from "../tokens-provider"
import { AppHeaderPresentation } from "./types"

export function AppHeaderStatusBar({
  presentation,
  headerMinHeight,
  headerMaxHeight,
}: {
  presentation: AppHeaderPresentation
  headerMinHeight: number
  headerMaxHeight: number
}): React.JSX.Element | null {
  const isFocused = useIsFocused()
  const { displayMode } = useTokens()
  const scrollOffset = useCurrentRouteScrollOffset()
  const [transparentStatusBarStyle, setTransparentStatusBarStyle] = useState<
    "dark" | "light"
  >("dark")

  useEffect(() => {
    if (presentation === "transparent" && displayMode === "light") {
      const listener = scrollOffset.addListener(
        ({ value }: { value: number }) => {
          // HACK: Ideally we would listen to the scrollInterpolation animated
          // value from `./container.tsx`, but that's broken in react-native so
          // we have to re-implement the "how much is the header animated in"
          // logic here. See:
          // https://github.com/facebook/react-native/issues/49719
          const headerOpacity =
            headerMaxHeight > headerMinHeight
              ? value / ((headerMaxHeight - headerMinHeight) * 2)
              : value / headerMinHeight
          const statusBarStyle = headerOpacity < 0.5 ? "dark" : "light"
          if (statusBarStyle !== transparentStatusBarStyle) {
            setTransparentStatusBarStyle(statusBarStyle)
          }
        },
      )
      return () => scrollOffset.removeListener(listener)
    }
  }, [
    presentation,
    scrollOffset,
    displayMode,
    transparentStatusBarStyle,
    headerMaxHeight,
    headerMinHeight,
  ])

  return isFocused && displayMode === "light" ? (
    <SystemBars
      style={{
        statusBar:
          presentation === "transparent" ? transparentStatusBarStyle : "light",
      }}
    />
  ) : null
}
